/**
 * *********************************************************************************************************************
 * Responsibility - First modal during the approval process if the user is approving/ rejecting all. This modal makes
 * the user acknowledge that they are about to perform an action on all the designs. 🐺
 * ************************************************************************************
 *
 * @format
 */

import {ModalHeader, ModalFooter, Modal} from '@sttark/design-system';
import {useProofingContext} from '../proofing_context_provider';
import React, {useState, useEffect} from 'react';
import {IfElse} from 'frontier-utilities';

// styles
import './modals.scss';

export const ApproveAll = props => {
    const proofingCtx = useProofingContext();
    const {children} = props;

    const {designsOrders, currentProof, isSubmitting, complete} = proofingCtx.data;
    const {handleApproveAll} = proofingCtx;

    const [isOpen, setIsOpen] = useState(false);

    const childWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                onClick: () => setIsOpen(true)
            });
        }
        return child;
    });

    const handleTriggerApprove = () => {
        handleApproveAll(currentProof.id);
    };

    useEffect(() => {
        if (complete > 0 && !isSubmitting) {
            setIsOpen(false);
        }
    }, [complete, isSubmitting]);

    return (
        <>
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} bodyHeightAuto>
                <ModalHeader>Approve All Artwork</ModalHeader>
                <div className="confirm-reject-approve-all-79lm__warning d-flex align-items-center justify-content-start gap-3">
                    <i className="fa fa-warning" />
                    <p className="approve-modal-23ll__p mt-0 mb-4">
                        <b>Warning!</b> You are about to approve the entire proof which includes{' '}
                        {designsOrders.length} pieces of artwork.
                    </p>
                </div>
                <p>
                    By clicking the Approve button below, you agree that you have read all comments
                    / notes, reviewed all artwork, and are approving the designs for printing.
                </p>
                <ModalFooter>
                    <IfElse condition={isSubmitting}>
                        <div className="d-flex align-items-center justify-content-end">
                            <button className="btn btn-disabled bg-structure-dark color-structure-darkest">
                                <b>Submitting your proof...</b>
                            </button>
                        </div>

                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <button onClick={() => setIsOpen(false)} className="btn btn--secondary">
                                <b>Cancel</b>
                            </button>
                            <button onClick={handleTriggerApprove} className="btn btn--primary">
                                <b>Approve All Artwork</b>
                            </button>
                        </div>
                    </IfElse>
                </ModalFooter>
            </Modal>
            <IfElse condition={!!children}>
                <>{childWithProps}</>
                <button>Approve</button>
            </IfElse>
        </>
    );
};
